export default __webpack_public_path__ + "static/media/no-claims.b267aa77.svg";